import HandleResponsesV2 from '@common/utils/handleApiResponsesV2';
import axios from '@/axios';

const actions = {
  async filter({ commit }, params) {
    try {
      let result = [];
      if (params.page === 1) {
        commit('setLoading', true);
      } else {
        commit('paginationCheck', true);
      }
      result = await axios('/order', { params });
      if (result && result.data) {
        commit('setList', result.data);
      }
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    } finally {
      commit('paginationCheck', false);
      commit('setLoading', false);
    }
  },
  async inspection({ commit }, { id, data }) {
    try {
      const result = await axios.put(`/order/${id}/inspection`, { data });
      if (result.data) {
        commit('setIndents', result.data);
      }
      return result.data;
    } catch (error) {
      if (error.status === 409) {
        return error.data;
      }
      return error;
    }
  },
  async inspectionAtDestination({ commit }, { id, data }) {
    try {
      const result = await axios.put(`/order/${id}/inspection_at_destination`, { data });
      if (result.data) {
        commit('setIndents', result.data);
      }
      return result.data;
    } catch (error) {
      return error;
    }
  },
  async locationMilestoneUpload(_, { formData }) {
    try {
      const result = await axios.post('/location_milestone/upload', formData, { headers: {
        'Content-Type': 'multipart/form-data',
      } });
      return result;
    } catch (error) {
      return error;
    }
  },
  async locationMilestoneUploadStatus({ commit }) {
    try {
      const result = await axios.get('/location_milestone/upload_status');
      if (result.data && result.data.code === 'COMPLETED') {
        commit('setuploadStatus', false);
      }
      return result.data;
    } catch (error) {
      commit('setuploadStatus', false);
      return error;
    }
  },
  async locationMilestoneDownloadInvalid(_, { transactionId }) {
    try {
      const result = await axios({ url: `/location_milestone/rejected/download?transaction_id=${transactionId}`,
        method: 'GET',
        responseType: 'blob' });
      let type = null;
      if (result && result.type === 'text/xml') {
        type = 'email';
      } else if (result) {
        const url = window.URL.createObjectURL(new Blob([result]));
        const link = document.createElement('a');
        link.href = url;
        const now = new Date().toISOString();
        link.setAttribute('download', `location-milestone-rejectedList-${now}.xlsx`); // or any other extension
        document.body.appendChild(link);
        link.click();
        type = 'download';
      }
      return type;
    } catch (err) {
      return err;
    }
  },

  async lrBulkUpload(_, { formData }) {
    try {
      const result = await axios.post('/lorry_receipt/bulk_upload', formData, { headers: {
        'Content-Type': 'multipart/form-data',
      } });
      return result;
    } catch (error) {
      return error;
    }
  },
  async lrBulkUploadStatus({ commit }) {
    try {
      const result = await axios.get('/lorry_receipt/upload_status');
      if (result.data && result.data.code === 'COMPLETED') {
        commit('setuploadStatus', false);
      }
      return result.data;
    } catch (error) {
      commit('setuploadStatus', false);
      return error;
    }
  },
  async lrDownloadInvalid(_, { transactionId }) {
    try {
      const result = await axios({ url: `/lorry_receipt/reject/download?transaction_id=${transactionId}`,
        method: 'GET',
        responseType: 'blob' });
      let type = null;
      if (result && result.type === 'text/xml') {
        type = 'email';
      } else if (result) {
        const url = window.URL.createObjectURL(new Blob([result]));
        const link = document.createElement('a');
        link.href = url;
        const now = new Date().toISOString();
        link.setAttribute('download', `lr-rejectedList-${now}.xlsx`); // or any other extension
        document.body.appendChild(link);
        link.click();
        type = 'download';
      }
      return type;
    } catch (err) {
      return err;
    }
  },
  async downloadLrBulkSample() {
    try {
      const result = await axios({ url: '/lr_sample_format',
        method: 'GET',
        responseType: 'blob' });
      if (result) {
        const url = window.URL.createObjectURL(new Blob([result]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'lr_Bulk_upload.xlsx');
        document.body.appendChild(link);
        link.click();
      }
      return true;
    } catch (err) {
      return err;
    }
  },

  async grnBulkUpload(_, { formData }) {
    try {
      const result = await axios.post('/order/grn_bulkupload', formData, { headers: {
        'Content-Type': 'multipart/form-data',
      } });
      return result;
    } catch (error) {
      return error;
    }
  },
  async grnBulkUploadStatus({ commit }) {
    try {
      const result = await axios.get('/order/grn_upload_status');
      if (result.data && result.data.code === 'COMPLETED') {
        commit('setuploadStatus', false);
      }
      return result.data;
    } catch (error) {
      commit('setuploadStatus', false);
      return error;
    }
  },
  async downloadGrnBulkSample() {
    try {
      const result = await axios({ url: '/order/download_grn_sample',
        method: 'GET',
        responseType: 'blob' });
      if (result) {
        const url = window.URL.createObjectURL(new Blob([result]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'transporter_grn_bulk_upload.xlsx');
        document.body.appendChild(link);
        link.click();
      }
      return true;
    } catch (err) {
      return err;
    }
  },
  async grnDownloadInvalid(_, { transactionId }) {
    try {
      const result = await axios({ url: `/order/rejected_grn/${transactionId}`,
        method: 'GET',
        responseType: 'blob' });
      if (result) {
        const url = window.URL.createObjectURL(new Blob([result]));
        const link = document.createElement('a');
        link.href = url;
        const now = new Date().toISOString();
        link.setAttribute('download', `grn-rejectedList-${now}.xlsx`);
        document.body.appendChild(link);
        link.click();
      }
      return true;
    } catch (err) {
      return err;
    }
  },
  async indentActionsSampleDownload() {
    try {
      const result = await axios({ url: '/order/actions/sample',
        method: 'GET',
        responseType: 'blob' });
      if (result) {
        const url = window.URL.createObjectURL(new Blob([result]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'indent_actions_upload.xlsx');
        document.body.appendChild(link);
        link.click();
      }
      return true;
    } catch (err) {
      return err;
    }
  },
  async consignmentDownloadInvalid(_, { transactionId }) {
    try {
      const result = await axios({ url: `/consignment/rejected/download?transaction_id=${transactionId}`,
        method: 'GET',
        responseType: 'blob' });
      let type = null;
      if (result && result.type === 'text/xml') {
        type = 'email';
      } else if (result) {
        const url = window.URL.createObjectURL(new Blob([result]));
        const link = document.createElement('a');
        link.href = url;
        const now = new Date().toISOString();
        link.setAttribute('download', `location-milestone-rejectedList-${now}.xlsx`); // or any other extension
        document.body.appendChild(link);
        link.click();
        type = 'download';
      }
      return type;
    } catch (err) {
      return err;
    }
  },
  async consignmentBulkUpload(_, { formData }) {
    try {
      const result = await axios.post('/consignment/upload', formData, { headers: {
        'Content-Type': 'multipart/form-data',
      } });
      return result;
    } catch (error) {
      return error;
    }
  },
  async chargeableWeightBulkUpload(_, { formData }) {
    try {
      const result = await axios.post('/order/chargeable_weight_bulk_upload', formData, { headers: {
        'Content-Type': 'multipart/form-data',
      } });
      return result;
    } catch (error) {
      return error;
    }
  },
  async indentActionsUpload(_, { formData }) {
    try {
      const result = await axios.post('/order/actions/upload', formData, { headers: {
        'Content-Type': 'multipart/form-data',
      } });
      return result;
    } catch (error) {
      return error;
    }
  },
  async consignmentUploadStatus({ commit }) {
    try {
      const result = await axios.get('/consignment/upload_status');
      if (result.data && result.data.code === 'COMPLETED') {
        commit('setuploadStatus', false);
      }
      return result.data;
    } catch (error) {
      commit('setuploadStatus', false);
      return error;
    }
  },
  async chargeableWeightUploadStatus({ commit }) {
    try {
      const result = await axios.get('/order/chargeable_weight_bulk_upload_status');
      if (result.data && result.data.code === 'COMPLETED') {
        commit('setuploadStatus', false);
      }
      return result.data;
    } catch (error) {
      commit('setuploadStatus', false);
      return error;
    }
  },
  async indentActionsUploadStatus({ commit }, { transactionId }) {
    try {
      const result = await axios.get(`/order/actions/upload_status?transaction_id=${transactionId}`);
      if (result.data && result.data.status === 'COMPLETED') {
        commit('setuploadStatus', false);
      }
      return result.data;
    } catch (error) {
      commit('setuploadStatus', false);
      return error;
    }
  },
  async chargeableWeightDownloadInvalid(_, { transactionId }) {
    try {
      const result = await axios({ url: `/order/download_chargeable_weight_rejected?transaction_id=${transactionId}`,
        method: 'GET',
        responseType: 'blob' });
      if (result) {
        const url = window.URL.createObjectURL(new Blob([result]));
        const link = document.createElement('a');
        link.href = url;
        const now = new Date().toISOString();
        link.setAttribute('download', `chargeable-weight-rejectedList-${now}.xlsx`); // or any other extension
        document.body.appendChild(link);
        link.click();
      }
      return result;
    } catch (err) {
      return err;
    }
  },
  async indentActionsRejectionDownload(_, { transactionId }) {
    try {
      const result = await axios({ url: `/order/actions/rejections?transaction_id=${transactionId}`,
        method: 'GET',
        responseType: 'blob' });
      if (result) {
        const url = window.URL.createObjectURL(new Blob([result]));
        const link = document.createElement('a');
        link.href = url;
        const now = new Date().toISOString();
        link.setAttribute('download', `indent-actions-rejectedList-${now}.xlsx`); // or any other extension
        document.body.appendChild(link);
        link.click();
      }
      return result;
    } catch (err) {
      return err;
    }
  },
  async consignmentDownloadInvalid(_, { transactionId }) {
    try {
      const result = await axios({ url: `/consignment/rejected/download?transaction_id=${transactionId}`,
        method: 'GET',
        responseType: 'blob' });
      let type = null;
      if (result && result.type === 'text/xml') {
        type = 'email';
      } else if (result) {
        const url = window.URL.createObjectURL(new Blob([result]));
        const link = document.createElement('a');
        link.href = url;
        const now = new Date().toISOString();
        link.setAttribute('download', `lr-rejectedList-${now}.xlsx`); // or any other extension
        document.body.appendChild(link);
        link.click();
        type = 'download';
      }
      return type;
    } catch (err) {
      return err;
    }
  },
  async bidsFilter({ commit }, params) {
    try {
      let result = [];
      if (params.page === 1) {
        commit('setLoading', true);
      } else {
        commit('paginationCheck', true);
      }
      result = await axios('/rfq', { params });
      if (result && result.data) {
        commit('setBidsList', result.data);
      }
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    } finally {
      commit('paginationCheck', false);
      commit('setLoading', false);
    }
  },

  async firstInTransporterList({ commit }, params) {
    try {
      let result = [];
      if (params.page === 1) {
        commit('setLoading', true);
      } else {
        commit('paginationCheck', true);
      }
      result = await axios('/first_in_allotment', { params });
      if (result && result.data) {
        commit('setFirstInTransporterList', result.data);
      }
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    } finally {
      commit('paginationCheck', false);
      commit('setLoading', false);
    }
  },

  async firstInTransporterAccept({ commit }, params) {
    try {
      const result = await axios.put(`/order/${params.orderNo}/first_in_allotment/accept`);
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },

  async indentRepublishRequestsList({ commit }, params) {
    try {
      if (params.page === 1) {
        commit('setLoading', true);
      } else {
        commit('paginationCheck', true);
      }
      const result = await axios('/auto_republish/order', { params });
      if (result && result.data) {
        commit('setIndentRepublishRequestsList', result.data);
      }
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    } finally {
      commit('paginationCheck', false);
      commit('setLoading', false);
    }
  },

  async indentRepublishRequestAccept({ commit }, params) {
    try {
      const result = await axios.put(`/order/${params.orderNo}/auto_republish/accept`);
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },

  async bidSettings(_, params) {
    try {
      const result = await axios.get('/depot/bid_settings', { params });
      return result.data;
    } catch (err) {
      return HandleResponsesV2.Status(err);
    }
  },
  async accept({ commit }, params) {
    try {
      const result = await axios.put(`/order/${params.orderNo}/accept`, { orderNumbers: params.orderNumbers });
      if (result.data) {
        commit('setIndents', result.data);
      }
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },
  async deliver({ commit }, { orderNo, data }) {
    try {
      const result = await axios.put(`/order/${orderNo}/deliver`, { data });
      if (result.data) {
        if (result.data.parent_indent_id) {
          commit('setReturnIndents', { data: result.data, masterOrderId: result.data.parent_indent_id });
        } else {
          commit('setIndents', result.data);
        }
      }
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },
  async containerPickup({ commit }, { orderNo, data }) {
    try {
      const result = await axios.put(`/order/${orderNo}/container_picked`, { data });
      if (result.data) {
        commit('setIndents', result.data);
      }
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },
  async getIndentDetails(_, params) {
    try {
      const result = await axios(`/order/${params.orderNo}`);
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },
  async reject({ commit }, { orderNo, data, ptlGroupId }) {
    try {
      const result = await axios.put(`/order/${orderNo}/reject`, { data }, { params: {
        ...ptlGroupId ? { ptl_group_id: ptlGroupId } : {},
      } });
      if (result.data) {
        commit('removeIndent', orderNo);
      }
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },
  async updateTruck({ commit }, { orderNo, data, ptlGroupId }) {
    try {
      const result = await axios.put(`order/${orderNo}/truck${ptlGroupId ? `?ptl_group_id=${ptlGroupId}` : ''}`, { data });
      if (result.data) {
        commit('setIndents', result.data);
      }
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },

  async calculateMaterialsLoad(_, { orderNos }) {
    try {
      const data = { orderNos };
      const result = await axios.put('/calculateMaterialsLoad', { data });
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },

  async activeTrip({ commit, state, dispatch }, params) {
    try {
      const result = await axios('/track-trip', { params });
      return result && result.data && result.data[0];
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },
  async isDuplicateVehicleAssignment({ commit }, { vehicleNumber, orderNo }) {
    try {
      const result = await axios.get(`/vehicle/${vehicleNumber}/indents?orderNo=${orderNo}`);
      return result && result.data;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },
  async isDetailsExist({ commit, state, dispatch }, { orderNo, vehicleNumber }) {
    try {
      const result = await axios.get(`/order/${orderNo}/is_vehicle_or_driver_number_exists?vehicle_number=${vehicleNumber}`);
      return result && result.data;
    } catch (err) {
      return HandleResponsesV2.Status(err);
    }
  },
  async updateTruckType({ commit }, { orderNo, data }) {
    try {
      const result = await axios.put(`order/${orderNo}/change_vehicle_type`, { data });
      if (result.data) {
        commit('setIndents', result.data);
      }
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },
  async updateHillyRegion({ commit }, { orderNo, data }) {
    try {
      const result = await axios.put(`order/${orderNo}/update_hilly_region`, { data });
      if (result.data) {
        commit('setIndents', result.data);
      }
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },
  async updateLR({ commit }, { orderNo, data }) {
    try {
      const result = await axios.put(`order/${orderNo}/lorry_receipt`, { data });
      if (result.data) {
        if (result.data.parent_indent_id) {
          commit('setReturnIndents', { data: result.data, masterOrderId: result.data.parent_indent_id });
        } else {
          commit('setIndents', result.data);
        }
      }
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },
  async updateMaterialInvoiceLR({ commit }, { orderId, data }) {
    try {
      const result = await axios.put(`order/${orderId}/material_invoice_lorry_receipt`, { data });
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },
  async updateConsignmentNumber({ commit }, { orderId, consigneeId, data }) {
    try {
      const result = await axios.put(`order/${orderId}/consignee/${consigneeId}/consignment_number`, { data });
      if (result.data) {
        if (result.data.parent_indent_id) {
          commit('setReturnIndents', { data: result.data, masterOrderId: result.data.parent_indent_id });
        } else {
          commit('setIndents', result.data);
        }
      }
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },
  async updateRfq({ commit }, { orderNo, data }) {
    if (orderNo) {
      try {
        const result = await axios.put(`order/${orderNo}/rfq`, { data });
        if (result.data) {
          commit('setBids', result.data);
        }
        return result;
      } catch (error) {
        return HandleResponsesV2.Status(error);
      }
    }
  },
  async getReturnIndents({ commit }, { masterOrderId, params }) {
    try {
      const result = await axios('/order', { params });
      if (result && result.data && result.data[0]) {
        commit('setReturnIndents', { data: result.data[0], masterOrderId });
      }
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },
  async getVehicleTypes({ commit }, { data }) {
    try {
      const result = await axios.put(`order/${orderNo}/rfq`, { data });
      if (result.data) {
        commit('GET_VEHICLE_TYPES', result.data);
      }
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },
  async getConsigneeMaterials(_, { indentNo, consigneeNo }) {
    try {
      const result = await axios.get(`order/${indentNo}/consignee/${consigneeNo}/material`);
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },
  async updateGrn(_, { indentNo, consigneeNo, data }) {
    try {
      const result = await axios.put(`order/${indentNo}/consignee/${consigneeNo}/grn`, { data });
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },
  async saveReturnMaterials(_, { indentNo, data, consigneeId }) {
    try {
      const result = await axios.put(`order/${indentNo}/consignee/${consigneeId}/return_materials`, { data });
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },
  async getLrAttachments(_, { orderId }) {
    try {
      const result = await axios.get(`/order/${orderId}/lr`);
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },
  async uploadDocument(_, formData) {
    try {
      const result = await axios.post('/attachment', formData, { headers: {
        'Content-Type': 'multipart/form-data',
      } });
      return result.data;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },
  async updateDocument(_, { indentNo, lorryReceipts }) {
    try {
      const result = await axios.put(`/order/${indentNo}/lorry_receipt`, { data: lorryReceipts });
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },
  async removeAttachment(_, { data }) {
    try {
      const result = await axios.delete(
        `order/${data.indentNo}/consignee/${data.consigneeNo}/lr/${data.file_id}`);
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },
  async addPod(_, { indentNo, destinationId, attachmentId }) {
    try {
      return await axios.put(`/order/${indentNo}/pod`, {
        data: [{ consignee_id: destinationId, pod_attachment_ids: [attachmentId] }],
      });
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },
  async addV1Attachment(_, { indentNo, destinationId, documentType, attachmentId }) {
    try {
      return await axios.post(`/v1/order/${indentNo}/attachment`, {
        destination_id: destinationId,
        document_type: documentType,
        attachment_id: attachmentId,
      });
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },
  async deleteV1Attachment(_, { indentNo, attachmentId, destinationId, documentType }) {
    try {
      return await axios.delete(`/v1/order/${indentNo}/attachment/${attachmentId}`, {
        data: { destination_id: destinationId, document_type: documentType },
      });
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },
  async truckIn({ commit }, { orderNo, data }) {
    try {
      const result = await axios.put(`/order/${orderNo}/truckIn`, { data });
      if (result.data) {
        commit('setIndents', result.data);
      }
      return result;
    } catch (error) {
      if (error.status === 409) {
        return error.data;
      }
      return HandleResponsesV2.Status(error);
    }
  },
  async truckOut({ commit }, { orderNo, data }) {
    try {
      const result = await axios.put(`/order/${orderNo}/truckOut`, { data });
      if (result.data) {
        commit('setIndents', result.data);
      }
      return result;
    } catch (error) {
      if (error.status === 409) {
        return error.data;
      }
      return HandleResponsesV2.Status(error);
    }
  },
  async confirmBooking({ commit }, { orderNo, bookingNumber }) {
    try {
      const data = {
        booking_confirmation_at: new Date(),
        booking_number: bookingNumber || '',
      };
      const result = await axios.put(`/order/${orderNo}/confirm_booking`, { data });
      if (result.data) {
        commit('setIndents', result.data);
      }
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },
  async getAttachmentsByIds(_, { ids, client_id, skipParentCheck = false }) { // eslint-disable-line
    try {
      const result = await axios('/attachment',
        { params: { ids, client_id, skip_parent: skipParentCheck } });
      return result.data;
    } catch (error) {
      return error;
    }
  },
  async updateMaterialComment(_, { orderNo, comment, materialId }) {
    try {
      const result = await axios.put(`/order/${orderNo}/${materialId}`, { data: comment });
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },
  async getVehicleNumberList(_, { data }) {
    try {
      const result = await axios.get('transporter/vehicle/search_vehicles', { params: data });
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },
  async location({ commit }, { orderNo }) {
    try {
      const result = await axios(`order/${orderNo}/track_location`);
      if (result) {
        // commit('SET_LOCATION_DATA', result);
        return result;
      }
      return false;
    } catch (err) {
      return false;
    }
  },
  async customFieldsMono(_, { payload, orderNo }) {
    try {
      const result = await axios.put(`/order/${orderNo}/custom_field_mono`, { data: payload });
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },
  async getLegalEntity(_, { orderNo }) {
    try {
      const result = await axios.get(`/order/${orderNo}/legal_entity`);
      return result.data;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },
  async getDriverNumberList(_, { data }) {
    try {
      const result = await axios.get('transporter/driver/search', { params: data });
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },
  async updateInspectionAttachment({ commit }, data) {
    try {
      const result = await axios.put(
        `/order/${data.orderNo}/inspection_attachment`,
        { data: data.inspectionAttachment });
      if (result.data) {
        commit('setIndents', result.data);
      }
      return result.data;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },

  async removeInspectionAttachment({ commit }, data) {
    try {
      const result = await axios.delete(
        `/order/${data.orderNo}/inspection_attachment/${data.file_id}`,
      );
      if (result.data) {
        commit('setIndents', result.data);
      }
      return result.data;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },
  async addAttachment(_, formData) {
    try {
      const result = await axios.post('attachment/',
        formData, { headers: { 'Content-Type': 'multipart/form-data' } });
      return result.data;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },
  async getComments(_, { orderNo, sectionNo }) {
    try {
      const result = await axios.get(`order/${orderNo}/comments?section=${sectionNo}`);
      return result.data;
    } catch (err) {
      return HandleResponsesV2.Status(err);
    }
  },
  async addComment({ commit }, { orderNo, commentData }) {
    try {
      const result = await axios.post(`order/${orderNo}/comments`, { data: { ...commentData } });
      return result.data;
    } catch (err) {
      return HandleResponsesV2.status(err);
    }
  },
  async getCommentAttachments({ commit }, {attachable_id} ) { // eslint-disable-line
    try {
      // eslint-disable-next-line camelcase
      const result = await axios.get(`/commentAttachment/${attachable_id}`);
      return result.data;
    } catch (error) {
      return error;
    }
  },

  async addCommentAttachment(_, { formData }) {
    try {
      const result = await axios.post('order/attachment', formData, { headers: {
        'Content-Type': 'multipart/form-data',
      } });
      return result.data;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },

  async ptlGroupActionStatus(_, { ptlGroupId, type }) {
    try {
      const result = await axios.get('/order/ptl_group_action_status', { params: { ptl_group_id: ptlGroupId, type } });
      return result && result.status;
    } catch (error) {
      return 'FAILED';
    }
  },
  async isPtlGrouping(_, { orderNo }) {
    try {
      const result = await axios.get(`/order/${orderNo}/ptl_grouping`);
      return result && result.data;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },
  async getReasonSettings(_, params) {
    try {
      let url = '/depot/reason_settings?';
      if (params.depot_id) {
        url = `${url}depot_id=${params.depot_id}`;
      }
      if (params.movement) {
        url = `${url}&movement=${params.movement}`;
      }
      if (params.type) {
        url = `${url}&type=${params.type}`;
      }
      const result = await axios.get(url);
      return result;
    } catch (err) {
      return HandleResponsesV2.Status(err);
    }
  },

  async saveShipmentDelay({ commit, state }, payload) {
    try {
      const result = await axios.post(`/order/${payload.orderNo}/shipmentDelay`, payload);
      if (result.data) {
        commit('setIndents', result.data);
      }
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },

  async downloadIndentDetails(_, orderNo) {
    try {
      const result = await axios({
        url: `order/${orderNo}/download_indent_details`,
        method: 'GET',
        responseType: 'blob',
      });
      if (result) {
        const url = window.URL.createObjectURL(new Blob([result]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `indent-details-${orderNo}.xlsx`);
        document.body.appendChild(link);
        link.click();
      }
      return true;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },
  async addV2Attachment(_, { indentNo, formData }) {
    try {
      const result = await axios.post(`/v2/order/${indentNo}/attachments`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return result.data;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },

  async deleteV2Attachment(_, { indentNo, attachmentId, payload }) {
    try {
      const result = await axios.delete(`/v2/order/${indentNo}/attachments/${attachmentId}`, { data: payload });
      return result.data;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },

  async listV2Attachments(_, { indentNo, destinationId } = {}) {
    try {
      const params = destinationId ? { destination_id: destinationId } : {};
      const result = await axios.get(`/v2/order/${indentNo}/attachments`, { params });
      return result.data;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },
};

export default actions;
